"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var core_1 = __importStar(require("@gin-betting/core"));
var types_1 = require("./types");
var constants_1 = require("./constants");
var actions_1 = require("./actions");
var extendHOC = core_1.default.hocs.extendHOC;
var _a = core_1.default.utils, isValidPropNames = _a.isValidPropNames, extendSearchString = _a.extendSearchString;
var NEEDED_KEYS = [
    'hasNext',
    'pages',
    'direction',
    'isLoadInitial',
    'categoryData',
];
function withPagination(WrappedComponent) {
    var PaginationWrapper = /** @class */ (function (_super) {
        __extends(PaginationWrapper, _super);
        function PaginationWrapper(props) {
            var _this = _super.call(this, props) || this;
            _this.validProps = false;
            _this.afterLoadScrollTimeout = null;
            _this.loadTimeout = null;
            _this.loadMoreWithPagination = function (loadingCallback) {
                var _a = _this.props, pages = _a.pages, direction = _a.direction, hasNext = _a.hasNext, fetchStatus = _a.categoryData.fetchStatus;
                var afterLoadScrolling = _this.state.afterLoadScrolling;
                var hasMore = direction === types_1.ScrollDirection.UP
                    ? pages.minPage > 1 && pages.currentPage === pages.minPage
                    : hasNext;
                var stillLoading = fetchStatus === core_1.App.FetchStatus.LOADING;
                if (!hasMore || stillLoading || afterLoadScrolling)
                    return;
                var diff = direction === types_1.ScrollDirection.UP
                    ? pages.currentPage - pages.minPage
                    : pages.maxPage - pages.currentPage;
                /* should load page only if pagination on the edge of max or min */
                if (diff !== 0)
                    return;
                _this.store.dispatch(actions_1.setMinAndMaxPages());
                if (loadingCallback) {
                    loadingCallback();
                }
            };
            _this.visibilityInitRef = function (page, instance) {
                var pages = _this.props.pages;
                /* this ref is needed only while initScrollNeeded and
                not scrolled yet to the very top or this is the very first element */
                if ((!_this.initScrollNeeded && pages.minPage === 1) ||
                    page !== pages.currentPage) {
                    return;
                }
                _this.firstElementInGroup = instance;
            };
            _this.handleVisibilityChange = function (page, isVisible, _a) {
                var bottom = _a.bottom;
                if (_this.initScrollNeeded)
                    return;
                var fetchStatus = _this.props.categoryData.fetchStatus;
                /* to calculate pagination (in general) and direction
                (before loading) all we need is "bottom-scroll" events only */
                var isBottomOfThePageScrollEventsOnly = (isVisible && bottom) || (!isVisible && !bottom);
                if (isBottomOfThePageScrollEventsOnly &&
                    fetchStatus !== core_1.App.FetchStatus.LOADING) {
                    _this.store.dispatch(actions_1.matchListPageChange(page, isVisible, bottom));
                }
                /* once appear at the very top need to open liveViewer */
                if (!_this.alreadyOpenStream && isVisible && bottom && page === 1) {
                    _this.store.dispatch(actions_1.openStreamAtVeryTop());
                    _this.alreadyOpenStream = true;
                }
            };
            _this.state = {
                afterLoadScrolling: false,
            };
            var pages = props.pages;
            if (lodash_1.isEmpty(pages)) {
                throw new Error('withPagination hoc requires `pages` in props');
            }
            _this.initScrollNeeded = pages.currentPage > 1;
            _this.alreadyOpenStream = false;
            _this.validProps = isValidPropNames(props, NEEDED_KEYS);
            return _this;
        }
        PaginationWrapper.prototype.UNSAFE_componentWillMount = function () {
            this.store.dispatch(actions_1.paginationInitialized());
        };
        PaginationWrapper.prototype.componentDidMount = function () {
            if (!this.initScrollNeeded && !this.alreadyOpenStream) {
                this.store.dispatch(actions_1.openStreamAtVeryTop());
                this.alreadyOpenStream = true;
            }
            var pages = this.props.pages;
            if (this.validProps && pages.currentPage < 2) {
                /* remove non-valid page from url */
                extendSearchString('page', null);
            }
        };
        PaginationWrapper.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
            var _this = this;
            var nextPages = nextProps.pages, _a = nextProps.categoryData, nextMatchIds = _a.matchIds, nextFetchStatus = _a.fetchStatus, nextIsLoadInitial = nextProps.isLoadInitial, nextDirection = nextProps.direction;
            var pages = this.props.pages;
            if (nextIsLoadInitial) {
                this.initScrollNeeded = nextPages.currentPage > 1;
            }
            /* writing new page to url */
            if (nextPages.currentPage !== pages.currentPage) {
                var isFirstPage = nextPages.currentPage < 2;
                var newPage = isFirstPage ? '' : "" + nextPages.currentPage;
                if (isFirstPage) {
                    this.store.dispatch(actions_1.openStreamAtVeryTop());
                }
                extendSearchString('page', newPage);
            }
            /* error: no results, need to show liveViewer */
            if (!this.alreadyOpenStream &&
                nextFetchStatus === core_1.App.FetchStatus.LOADED &&
                nextMatchIds.size < 1) {
                this.store.dispatch(actions_1.openStreamAtVeryTop());
                this.alreadyOpenStream = true;
            }
            /* if previous page was loaded */
            if ((nextMatchIds.size > this.props.categoryData.matchIds.size ||
                nextFetchStatus === core_1.App.FetchStatus.LOADED) &&
                nextDirection === types_1.ScrollDirection.UP) {
                /* page at the very top then need to scroll down a little bit */
                if (nextPages.minPage > 1 && window.pageYOffset < constants_1.THRESHOLD) {
                    this.setState({ afterLoadScrolling: true });
                    window.scroll({
                        top: constants_1.THRESHOLD * 2,
                        behavior: 'smooth',
                    });
                    /* FIXME */
                    this.afterLoadScrollTimeout = window.setTimeout(function () {
                        _this.setState({ afterLoadScrolling: false });
                        _this.afterLoadScrollTimeout = null;
                    }, 1000);
                }
                /* load first page, need to check if visibility filter was triggered */
                if (nextPages.minPage !== this.props.pages.minPage &&
                    nextPages.minPage === 1 &&
                    nextPages.currentPage !== 1) {
                    this.store.dispatch(actions_1.matchListPageChange(1, true, true));
                }
            }
        };
        PaginationWrapper.prototype.componentDidUpdate = function () {
            if (this.initScrollNeeded && this.firstElementInGroup) {
                /* no auto-scroll */
                if ('scrollRestoration' in history) {
                    history.scrollRestoration = 'manual';
                }
                this.firstElementInGroup.scrollIntoView({
                    block: 'start',
                    behavior: 'auto',
                });
                this.initScrollNeeded = false;
            }
        };
        PaginationWrapper.prototype.componentWillUnmount = function () {
            /* drop previous state for new list type */
            this.store.dispatch(actions_1.dropPaginationState());
            if (this.afterLoadScrollTimeout) {
                clearTimeout(this.afterLoadScrollTimeout);
            }
        };
        // TODO: review injectVisibilityFlag, look into Intersection Observer
        PaginationWrapper.prototype.injectVisibilityFlagsToMatchIds = function () {
            var _a = this.props, matchIds = _a.categoryData.matchIds, pages = _a.pages;
            var limitPerPage = pages.limitPerPage, minPage = pages.minPage;
            var matchIdsWithVisibilityFlags = matchIds
                .toList()
                .flatMap(function (id, index) {
                if (!(index % limitPerPage)) {
                    /* adding extra flag for every first row in block */
                    var page = index / limitPerPage + minPage;
                    return ["visibility" + page, id];
                }
                return [id];
            })
                .toOrderedSet();
            return matchIdsWithVisibilityFlags;
        };
        PaginationWrapper.prototype.render = function () {
            var _a = this.props, pages = _a.pages, direction = _a.direction, hasNext = _a.hasNext;
            var isUp = direction === types_1.ScrollDirection.UP;
            var hasMore = isUp
                ? pages.minPage > 1 && pages.currentPage === pages.minPage
                : hasNext;
            var matchIdsWithVisibilityFlags = this.injectVisibilityFlagsToMatchIds();
            var paginatedProps = {
                isUp: isUp,
                hasMore: hasMore,
                loadMoreWithPagination: this.loadMoreWithPagination,
                matchIdsWithVisibilityFlags: matchIdsWithVisibilityFlags,
                handleVisibilityChange: this.handleVisibilityChange,
                visibilityInitRef: this.visibilityInitRef,
            };
            return this.validProps ? (react_1.default.createElement(WrappedComponent, __assign({}, this.props, paginatedProps))) : (react_1.default.createElement(WrappedComponent, __assign({}, this.props)));
        };
        return PaginationWrapper;
    }(react_1.default.Component));
    return extendHOC(WrappedComponent, PaginationWrapper, { withStore: true });
}
exports.default = withPagination;
//# sourceMappingURL=withPagination.js.map